/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Actionplacecardbody3Inputs */

const en_actionplacecardbody3 = /** @type {(inputs: Actionplacecardbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send your favourites a short action. It also shows on your place page and in the feed.`)
};

const de_actionplacecardbody3 = /** @type {(inputs: Actionplacecardbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schick deinen Favoriten eine kurze Aktion. Sie steht auch auf deiner Ortsseite und im Feed.`)
};

/**
* | output |
* | --- |
* | "Send your favourites a short action. It also shows on your place page and in the feed." |
*
* @param {Actionplacecardbody3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const actionplacecardbody3 = /** @type {((inputs?: Actionplacecardbody3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Actionplacecardbody3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_actionplacecardbody3(inputs)
	return de_actionplacecardbody3(inputs)
});
export { actionplacecardbody3 as "actionPlaceCardBody" }